module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av487-e5b48d6e42233035ed6bdcc3b49ede0a.jpg";